import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById('root');
if (!root) throw new Error('Application mount is missing');
// SEO output is readable HTML, not a matching React hydration tree. Keep it
// visible until the lazy route and its primary data have actually committed.
if (root.hasChildNodes()) {
  const staticContent = document.createElement('div');
  staticContent.id = 'prerender-content';
  while (root.firstChild) staticContent.appendChild(root.firstChild);
  root.before(staticContent);
  root.hidden = true;
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
